/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Filter_CategoryInputs */

const en_us2_exercise_filter_category = /** @type {(inputs: Exercise_Filter_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

const pt_br2_exercise_filter_category = /** @type {(inputs: Exercise_Filter_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria`)
};

const es_419_exercise_filter_category = /** @type {(inputs: Exercise_Filter_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoría`)
};

const pt_pt2_exercise_filter_category = /** @type {(inputs: Exercise_Filter_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria`)
};

const fr_fr2_exercise_filter_category = /** @type {(inputs: Exercise_Filter_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie`)
};

const de_de2_exercise_filter_category = /** @type {(inputs: Exercise_Filter_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie`)
};

const it_it2_exercise_filter_category = /** @type {(inputs: Exercise_Filter_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria`)
};

/**
* | output |
* | --- |
* | "Category" |
*
* @param {Exercise_Filter_CategoryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_filter_category = /** @type {((inputs?: Exercise_Filter_CategoryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Filter_CategoryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_filter_category(inputs)
	if (locale === "es-419") return es_419_exercise_filter_category(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_filter_category(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_filter_category(inputs)
	if (locale === "de-DE") return de_de2_exercise_filter_category(inputs)
	if (locale === "it-IT") return it_it2_exercise_filter_category(inputs)
	return en_us2_exercise_filter_category(inputs)
});
export { exercise_filter_category as "exercise.filter_category" }